import React from "react";
import TabNav from "./tab/TabNav";

import { TabProvider } from "../contexts/tab";
import TabPagination from "./tab/TabPagination";
import TabBody from "./tab/tabBody";
import { useAuth } from "../contexts/auth";
import { ErrorBoundary } from "react-error-boundary";
import FallbackComponent from "./fallbackRenders/FallbackComponent";

export default function DataPage() {
  return (
    <div className="h-full p-4 overflow-y-auto">
      <TabProvider>
        <TabNav />
        <ErrorBoundary fallbackRender={FallbackComponent}>
          <TabBody />
        </ErrorBoundary>
        <ErrorBoundary fallbackRender={FallbackComponent}>
          <TabPagination />
        </ErrorBoundary>
      </TabProvider>
    </div>
  );
}
